import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { IconButton } from '@material-ui/core';
import {
  HeadsetMic,
  Close as CloseIcon,
  Mic as MicIcon,
  MicOff as MicOffIcon,
} from '@material-ui/icons';
import * as lib from '~/dependencies';
import { useControlSessions } from '~/hooks';
import * as actionTypes from '~/store/actions/actionTypes';
import DeviceManager from '../DeviceManager';

import { Dialog, DialogContent, DialogTitle, Button } from './styles';

export default function HeadsetManager() {
  // STATES
  const [openDialog, setOpenDialog] = useState(false);

  // HOOKS
  const controlSessions = useControlSessions();
  const { t } = lib.useTranslation();

  const currentCalls = useSelector(state => state.callCurrent?.data);
  const isConference = currentCalls?.length
    ? !!currentCalls.filter(c => c.status === actionTypes.CALL_CONFERENCE)
        ?.length
    : false;

  const isMuted = currentCalls?.length
    ? !!currentCalls.filter(c => c.mute === true)?.length
    : false;

  function handleOpenHeadsetManager() {
    setOpenDialog(!openDialog);
  }

  function handleConferenceMicState(nextMicState) {
    if (currentCalls?.length) {
      currentCalls.forEach(c => {
        if (c.id) {
          controlSessions(c.id, nextMicState);
        }
      });
    }
  }

  return (
    <>
      <div className="buttons-container">
        {isConference && (
          <>
            {isMuted ? (
              <Button
                aria-controls="fade-menu"
                aria-haspopup="true"
                disableRipple
                onClick={() => handleConferenceMicState('unmute')}>
                <MicOffIcon
                  titleAccess={t('components.activeCalls.btn.unmute')}
                />
              </Button>
            ) : (
              <Button
                aria-controls="fade-menu"
                aria-haspopup="true"
                disableRipple
                onClick={() => handleConferenceMicState('mute')}>
                <MicIcon titleAccess={t('components.activeCalls.btn.mute')} />
              </Button>
            )}
          </>
        )}

        <Button
          data-testid="headset-manager-button"
          aria-controls="fade-menu"
          aria-haspopup="true"
          onClick={handleOpenHeadsetManager}
          disableRipple>
          <HeadsetMic
            titleAccess={t('components.headsetManager.titleAccess')}
          />
        </Button>
      </div>
      <Dialog
        open={openDialog}
        onClose={handleOpenHeadsetManager}
        aria-labelledby="customized-dialog-title">
        <DialogTitle id="customized-dialog-title" disableTypography>
          <span>{t('components.headsetManager.title')}</span>
          <IconButton
            aria-label="close"
            style={{ padding: 3 }}
            onClick={handleOpenHeadsetManager}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <DeviceManager disableRingDevice disableAudioTest showSpeakerVolume />
        </DialogContent>
      </Dialog>
    </>
  );
}
